import queryString from 'query-string'

const SUBSCRIPTIONS_URL = `${process.env.MICRO_FRONTEND_URL}/subscriptions/subscriptions.js`

const isDevMode = process.env.BUILD_ENV !== 'production'

export const getQueryString = (project: string) => {
  const queryParams: { [key: string]: string } = {}

  if (process.env.HEAD) {
    queryParams['wb'] = process.env.HEAD
  }

  if (process.env.RELEASE_TAG) {
    queryParams['wv'] = process.env.RELEASE_TAG?.replace(/\./g, '-') // 1.2.3 -> 1-2-3 since there shouldn't be dots in query params
  }

  const generatedQueryString = queryString.stringify(queryParams)

  const versionQueryString = generatedQueryString
    ? `&${generatedQueryString}`
    : ''

  return `?p=${project}${versionQueryString}`
}

const MFE_CONFIG = {
  subscriptions: {
    home: {
      projectName: 'subscriptions',
      componentName: 'Subscription',
      url: SUBSCRIPTIONS_URL,
      isDevMode,
      queryString: getQueryString('subscriptions'),
    },
  },
}

export { MFE_CONFIG }
